module.exports = __webpack_public_path__ + "img/gz.e5eea3ad.svg";